import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';

export default VueSidebarMenu;



// WEBPACK FOOTER //
// ./src/plugins/sidebar.js